<template>
  <div class="uid-guide-popup">
    <em class="uid-guide-mask" @click="hidePopup"></em>
    <div class="uid-guide-box">
      <div class="uid-guide-box-title">
        {{ letter.howToFindUid }}
      </div>
      <div class="uid-guide-box-detail">
        <p class="step">
          <span class="step-order">Step1：</span>{{ letter.storeUidGuideStep1 }}
        </p>
        <div class="img-wrap">
          <img :src="inGameGuideImg1" class="img img1" alt="" />
        </div>
        <p class="step">
          <span class="step-order">Step2：</span>{{ letter.storeUidGuideStep2 }}
        </p>
        <div class="img-wrap">
          <img :src="inGameGuideImg2" class="img img2" alt="" />
        </div>
      </div>
      <a
        class="uid-guide-popup-close click-uid-guide-close"
        @click="hidePopup"
      ></a>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
  computed: {
    ...mapState({
      letter: state => state.letter
    }),
    ...mapGetters(['gameInfoConfig']),
    inGameGuideImg1() {
      return this.gameInfoConfig.uidGuidePopupGameImg1;
    },
    inGameGuideImg2() {
      return this.gameInfoConfig.uidGuidePopupGameImg2;
    }
  },
  methods: {
    hidePopup() {
      this.$emit('hidePopup');
    }
  }
};
</script>

<style scoped lang="scss">
@import '@assets/scss/officialStore/officialStore.scss';
.uid-guide-popup {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 10;
  width: 100%;
  height: 100%;
  .uid-guide-mask {
    position: absolute;
    left: 0;
    top: 0;
    z-index: -1;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    cursor: pointer;
  }
  .uid-guide-box {
    position: absolute;
    left: 50%;
    top: 50%;
    background-size: cover;
    transform: translate(-50%, -50%);
    @psetbg ('uid-popup.png');
    &-title {
      margin: 82px auto 42px;
      text-align: center;
      font-weight: bold;
      font-size: 44px;
      color: var(--global-tip-popup-title);
    }
    &-detail {
      overflow-x: hidden;
      overflow-y: scroll;
      padding: 0 45px;
      height: 582px;
      color: var(--login-uid-guide-popup-step);
      .step {
        text-align: left;
        font-weight: bold;
        font-size: 28px;
      }
      .step-order {
        font-weight: bold;
        font-size: 36px;
      }
      .img-wrap {
        margin-top: 12px;
        margin-bottom: 38px;
        padding: 20px;
        background: rgba(0, 0, 0, 0.4);
        .img {
          margin: 0 auto;
          max-width: 100%;
          background-size: cover;
        }
      }
    }
  }
  &-close {
    position: absolute;
    right: 46px;
    top: 37px;
    z-index: 11;
    background-size: cover;
    cursor: pointer;
    @psetbg ('close.png');
  }
}
@media screen and (orientation: landscape) {
  .uid-guide-popup {
    .uid-guide-box {
      // 这里
      position: absolute;
      @psetbg ('uid-popup-hen.png');
      &-title {
        margin-top: 58px;
        margin-bottom: 34px;
        font-size: 30px;
      }
      &-detail {
        overflow: -moz-scrollbars-none;
        padding: 0 28px;
        height: 373px;

        -ms-overflow-style: none;
        scrollbar-width: none;
        &::-webkit-scrollbar {
          display: none;
          width: 0 !important;
        }
        .step {
          font-size: 18px;
        }
        .step-order {
          font-size: 24px;
        }
        .img-wrap {
          margin-bottom: 35px;
        }
      }
    }
    &-close {
      position: absolute;
      right: 31px;
      top: 23px;
      z-index: 10;
      @psetbg ('close-hen.png');
    }
  }
}
</style>
